import { signal, Signal } from '@preact/signals'
import { LoadingStatusSubscriber, loadingStatus } from '@scandit/web-datacapture-core'
import AppStore from './AppStore'

export type TLoadingStore = { percentage: Signal<number>; startListening: () => void; stopListening: () => void }
export const LoadingStore = (appStore: AppStore): TLoadingStore => {
  const loadingPercentage = signal(0)
  const subscriber: LoadingStatusSubscriber = (progressInfo) => {
    loadingPercentage.value = progressInfo.percentage ?? 0
  }

  return {
    percentage: loadingPercentage,
    startListening() {
      loadingPercentage.value = 0
      loadingStatus.subscribe(subscriber)
    },
    stopListening() {
      loadingStatus.unsubscribe(subscriber)
    },
  }
}
